import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { AuthService } from '../../auth/services/auth.service';
import { initFlowbite } from 'flowbite';
import { CommonModule } from '@angular/common';
import { RouterModule, Router, NavigationEnd } from '@angular/router';
import { SpinnerService } from '../spinner/spinner.service';
import { MatIconModule } from '@angular/material/icon';
import { filter, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-sidebar-admin',
  standalone: true,
  imports: [CommonModule, RouterModule, MatIconModule],
  templateUrl: './sidebar-admin.component.html',
  styleUrl: './sidebar-admin.component.scss'
})
export class SidebarAdminComponent implements OnInit, OnDestroy {
  authService = inject(AuthService);
  spinnerService = inject(SpinnerService);
  router = inject(Router);

  menu: any[] = [];
  openMenuId: number | null = null;
  currentUrl: string = '';
  private destroy$ = new Subject<void>();

  ngOnInit(): void {
    initFlowbite();

    // Detectar cambios de ruta
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: any) => {
      this.currentUrl = event.url;
      this.setActiveMenuFromUrl();
    });

    this.currentUrl = this.router.url;

    this.authService.user$.pipe(
      takeUntil(this.destroy$)
    ).subscribe(response => {
      if (response) {
        this.getMenu(response.id);
      }
    });
  }

  getMenu(user_id: number) {
    this.spinnerService.startRequest();
    this.authService.getMenu(user_id).subscribe((response: any) => {
      if (response.success) {
        this.menu = response.data;
        setTimeout(() => {
          this.setActiveMenuFromUrl();
          this.spinnerService.endRequest();
        }, 300);
      } else {
        this.menu = [];
        this.spinnerService.endRequest();
      }
    });
  }

  toggleMenu(menuId: number) {
    if (this.openMenuId === menuId) {
      this.openMenuId = null;
    } else {
      this.openMenuId = menuId;
    }
  }

  isMenuOpen(menuId: number): boolean {
    return this.openMenuId === menuId;
  }

  isActiveRoute(url: string): boolean {
    return this.currentUrl === url;
  }

  isGroupActive(item: any): boolean {
    if (item.group === 'false') {
      return this.isActiveRoute(item.url);
    } else if (item.submenu) {
      return item.submenu.some((sub: any) => this.isActiveRoute(sub.url));
    }
    return false;
  }

  setActiveMenuFromUrl() {
    // Encontrar el menú que contiene la ruta actual y abrirlo
    const activeMenu = this.menu.find(item => {
      if (item.group === 'true' && item.submenu) {
        return item.submenu.some((sub: any) => this.currentUrl === sub.url);
      }
      return false;
    });

    if (activeMenu) {
      this.openMenuId = activeMenu.menu_id;
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}